import { render } from "./Block.vue?vue&type=template&id=2c8b1ceb"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=2c8b1ceb&lang=css"
script.render = render

export default script